import { createContext } from "react";

export type UserContextType = {
   user: any;
   setUser: Function;
   hasPermission: (priv: string) => boolean;
};

const UserContext = createContext<UserContextType>({
   user: undefined,
   setUser: () => console.error("Not implemented"),
   hasPermission: (priv: string) => false,
});

export default UserContext;
